/**
 * Kayıt sonrası ödeme yolu — saf biçim süzgeci.
 *
 * Fiyat sayfası "Satın al" → başvuru → davet bağlantısı (?paket=KOD) → kayıt → üyelik ödeme.
 * Bu dosya yalnız biçim süzgeci; paketin satışta olup olmadığına
 * arka uç (istenenPaketDogrula) ve üyelik sayfası bakar.
 */

const KOD_REGEX = /^[A-Z][A-Z0-9_]{1,39}$/;
const YASAKLI = new Set(['FREE', 'ENTERPRISE']);

export function paketKoduOku(deger: unknown): string | null {
  let v: unknown = deger;
  if (Array.isArray(v)) {
    v = v.length > 0 ? v[0] : null;
  }
  if (typeof v !== 'string') return null;
  if (!KOD_REGEX.test(v)) return null;
  if (YASAKLI.has(v)) return null;
  return v;
}

export function kayitSonrasiYol(kod: unknown): string {
  const k = paketKoduOku(kod);
  if (k !== null) {
    return `/dashboard?settings=uyelik&paket=${k}`;
  }
  return '/dashboard';
}

const ISTENEN_PAKET_ANAHTAR = 'riskmatik.istenenPaket';

/**
 * Seçilen paket kodu sekme belleğine (sessionStorage) yazılır.
 * `paketKoduOku`'dan geçerse yazar, geçmezse anahtarı siler.
 * `window` yoksa sessiz; bellek erişimi hatasızsa try/catch.
 */
export function istenenPaketiSakla(kod: unknown): void {
  try {
    if (typeof window === 'undefined') return;
    const ss = window.sessionStorage;
    const gecdi = paketKoduOku(kod);
    if (gecdi !== null) {
      ss.setItem(ISTENEN_PAKET_ANAHTAR, gecdi);
    } else {
      ss.removeItem(ISTENEN_PAKET_ANAHTAR);
    }
  } catch {
    // sessiz — gizli sekme / erişim engeli
  }
}

/**
 * Saklanan paket kodu `paketKoduOku` süzgecinden geçirilip döner; yoksa null.
 * `window` yoksa veya bellek erişilemezse null.
 */
export function istenenPaketiAl(): string | null {
  try {
    if (typeof window === 'undefined') return null;
    const ss = window.sessionStorage;
    const deger = ss.getItem(ISTENEN_PAKET_ANAHTAR);
    if (deger === null) return null;
    return paketKoduOku(deger);
  } catch {
    return null;
  }
}
